<template>
  <div class="main">
    <div class="container">
      <ul class="breadcrumb">
        <li>
          您所在的位置：
        </li>
        <li class="alpha hover">
          <a>首页</a>
        </li>
        <li class="alpha hover" @click="$router.push('/')">
          <a>暂停通讯工具号码网上公示</a>
        </li>
        <li class="active">
          违法行为信息
        </li>
      </ul>
      <div class="box box-default">
        <div class="case-detail">
          <h3>
            违法行为信息
          </h3>
          <table class="table table-bordered table-custom table-detail">
            <tbody>
            <tr>
              <th style="width: 20%">
                号码
              </th>
              <td>
                {{ info.tel }}
              </td>
            </tr>
            <tr>
              <th>
                违法地点
              </th>
              <td>
                {{ info.caseoccuraddress }}
              </td>
            </tr>
            <tr>
              <th>
                执法单位名称
              </th>
              <td>
                {{ info.penaltyorganname }}
              </td>
            </tr>
            <tr>
              <th>
                公示日期
              </th>
              <td>
                {{ info.publicdate ? info.publicdate.split(' ')[0]: '' }}
              </td>
            </tr>
            <tr>
              <th>
                受理地点
              </th>
              <td>
                {{ info.penaltyorganaddress }}
              </td>
            </tr>
            <tr>
              <th>
                联系电话
              </th>
              <td>
                {{ info.penaltyorgantel }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getCaseInfoDetail} from '@/http'

export default {
  data() {
    return {
      info: {}
    }
  },
  methods: {},
  created() {
    getCaseInfoDetail(this.$route.query.guid).then(res => {
      this.info = res
    })
  }
}
</script>
<style lang="less">
#app, pageFooter {
  //background-color: #EBE9EA;
}

.main {
  .container {
    width: 1000px;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;

    .breadcrumb {
      background-color: transparent;
      font-size: 14px;
      margin-bottom: 10px;
      padding: 0 8px 10px 0;
      list-style-type: none;

      li + li:before {
        content: ">";
        color: #333;
        padding: 0 5px;
      }

      :nth-child(2):before {
        display: none;
      }

      .hover {
        cursor: pointer;
      }

      li {
        display: inline-block;
      }

      .alpha {
        a {
          color: #333;
        }
      }

      .active {
        color: #777;
      }
    }

    .table-bordered {
      border: 1px solid #ddd;
    }

    .case-detail {
      padding: 30px 50px;
      background-color: #fff;
      color: #333;

      h3 {
        margin: 0 0 20px 0;
        font-size: 18px;
        font-weight: 400;
      }
    }

    .table {
      width: 100%;
      max-width: 100%;
      margin-bottom: 20px;
      background-color: transparent;
      border-spacing: 0;
      border-collapse: collapse;
    }

    .table-custom th, .table-custom td {
      padding: 15px 8px !important;
      border-color: #54A7C8 !important;
    }

    .table-custom th {
      background-color: #D8F5FB;
      text-align: right;
      font-weight: normal;
      font-size: 15px;
      border: 1px solid #ddd;
    }

    .table-custom td {
      padding: 15px 8px !important;
      border-color: #54A7C8 !important;
      font-size: 14px;
      border: 1px solid #ddd;
      line-height: 1.42857143;
      vertical-align: top;
    }
  }
}

</style>
